import script from "./CavalosXAulas.vue?vue&type=script&setup=true&lang=js"
export * from "./CavalosXAulas.vue?vue&type=script&setup=true&lang=js"

import "./CavalosXAulas.vue?vue&type=style&index=0&id=5dd4d5ae&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5dd4d5ae"]])

export default __exports__